import axios, { AxiosError } from 'axios';

export const api = axios.create({
  baseURL: import.meta.env?.VITE_API_URL ?? '',
  withCredentials: true,
  timeout: 15_000,
});

api.interceptors.response.use(
  (r) => r,
  (err: AxiosError<{ error?: string; message?: string }>) => {
    // Глобально логируем 5xx, остальное оставляем компонентам.
    if (err.response && err.response.status >= 500) {
      // eslint-disable-next-line no-console
      console.error('[api]', err.response.status, err.response.data);
    }
    return Promise.reject(err);
  },
);
